import { getDeepLinkPath } from 'domains/teams/selectors';
import { useSelector } from 'hooks/useSelector';
import type { useLocation } from 'react-router';

export const useIsDeepLinkPage = (location: ReturnType<typeof useLocation>) => {
  const deepLinkPath = useSelector(getDeepLinkPath);

  if (!deepLinkPath) {
    return false;
  }

  const fullPath = `${location.pathname}${location.search}`;

  return fullPath === deepLinkPath;
};
